<script setup lang="ts">
import { odsNavigation, odsNavigationItem } from "omind-design-system/components/odsNavigation"
import router, { isActiveRoute, isExactActiveRoute } from "@/router";
import { getClientListRouteLocation } from "@/domains/-coachee/-list/routes";
import { getEventsRouteLocation, getGlossaryRouteLocation, getResourcesRouteLocation } from "@/domains/-community/routes";
import { useSessionStore } from "@/domains/-session/stores/useSessionStore"
import { resetCoacheesListQuery } from '@/domains/-session/functions/coacheesListQuery.ts';
import { computed, ref } from "vue";
import { onMounted } from "vue";
import { isInLocalDevelopmentMode } from "@/functions/development";
import sdk from "@/sdk";

const SESSION = useSessionStore()

const communityGroupItem = ref()
const analysisGroups = ref()

onMounted(async () => {
    if (!hasBootcamp.value)
        communityGroupItem.value.open()
})

const hasBootcamp = computed(() => {
    //return isInLocalDevelopmentMode()
    return SESSION.wsp?.workspace.config.allow_ai_bootcamp
})

async function gotoToCollective() {
    analysisGroups.value = (await sdk.getAnalysisGroups(parseInt(router.currentRoute.value.params.workspaceId as string, 10))).data
    if (analysisGroups.value.length > 0)
        router.push({ name: 'collective-tools-list' })
    else
        router.push({ name: 'collective-tools-landing' })
}
</script>

<template>
    <odsNavigation>
        <!-- <odsNavigationItem
            :icon="'space_dashboard'"
            :label="$t('navigation.dashboard')"
            :to="getClientListRouteLocation(1) as object"
        /> -->
        <!-- <odsNavigationItem
            :icon="'group'"
            :label="$t('navigation.clients')"
            :to="getClientListRouteLocation(SESSION.wsp?.workspace.id!,undefined,true) as object"
        /> -->
        <odsNavigationItem :icon="'group'"
                           :label="$t('navigation.clients')"
                           :to="{ name: 'coachee_list', query: { reset: 1 } }" />
        <odsNavigationItem v-if="hasBootcamp"
                           :icon="'hive'"
                           :label="$t('navigation.bootcamps')"
                           :to="{ name: 'bootcamp_list' }" />
        <odsNavigationItem :icon="'analytics'"
                           :label="$t('navigation.group_analysis')"
                           :class="{ 'router-link-active': ['collective-tools-landing', 'collective-tools-list'].includes(router.currentRoute.value.name as string) }"
                           :to="{ name: 'collective-tools-list' }"
                           @click.cancel="gotoToCollective" />
        <div class="separator"></div>
        <odsNavigationItem ref="communityGroupItem"
                           :icon="'handshake'"
                           :label="$t('navigation.community')"
                           :group="true">
            <odsNavigationItem :label="$t('navigation.community_events')"
                               :to="{ name: 'events' }" />
            <odsNavigationItem :label="$t('navigation.community_news')"
                               :to="{ name: 'events', hash: '#news' }" />
            <odsNavigationItem :label="$t('navigation.community_resources')"
                               :to="{ name: 'resources' }" />
            <odsNavigationItem :label="$t('navigation.community_glossary')"
                               :to="{ name: 'glossary' }" />
        </odsNavigationItem>

        <!-- <odsNavigationItem
            :icon="'handshake'"
            :label="$t('navigation.community')"
            :to="getCommunityRouteLocation(SESSION.wsp?.workspace.id!) as object"
        /> -->
        <!-- <odsNavigationItem
            :icon="'contacts'"
            :label="$t('navigation.glossary')"
            :to="getGlossaryRouteLocation(SESSION.wsp?.workspace.id!) as object"
        /> -->
    </odsNavigation>
</template>

<style lang="scss">
.ods-navigation {
    .separator {
        width: 100%;
        height: 0.0625rem;
        opacity: 0.2;
        background: #FFF;
    }
}
</style>